// Inspired by https://github.com/kanety/stimulus-dialog
import { Controller } from "@hotwired/stimulus";
import "@kanety/stimulus-static-actions";

export default class UIDialog extends Controller {
  static targets = ["dialog", "modal", "focus", "drag", "backdrop", "closeButton", "loaderTemplate"];
  static values = { href: String, open: Boolean };

  static actions = [
    ["element", "keydown@window->closeByKey"],
    ["modal", "click->closeByModal"],
    ["closeButton", "click->close"],
  ];

  connect() {
    if (this.openValue) {
      this.openBy(this.element);
    }
  }

  open(e) {
    this.openBy(e.target);
    e.preventDefault();

    if (this.hrefValue) {
      const contentDiv = this.dialogTarget.querySelector(".dialog-content-container");
      const loaderTemplate = this.hasLoaderTemplateTarget ? this.loaderTemplateTarget : null;

      if (contentDiv && loaderTemplate) {
        const loaderClone = loaderTemplate.content.cloneNode(true);
        contentDiv.innerHTML = "";
        contentDiv.appendChild(loaderClone);
      }

      $.ajax({
        url: this.hrefValue,
        method: "GET",
        dataType: "script",
      })
    }
  }

  close(e) {
    this.closeBy(e.target);
    e.preventDefault();
  }

  toggle(e) {
    if (this.isVisible()) {
      this.closeBy(e.target);
    } else {
      this.openBy(e.target);
    }
    e.preventDefault();
  }

  closeByKey(e) {
    if (e.keyCode == 27) {
      this.closeBy(e.target);
      e.preventDefault();
    }
  }

  closeByModal(e) {
    if (!this.dialogTarget.contains(e.target)) {
      this.closeBy(e.target);
    }
  }

  isVisible() {
    return this.dialogTarget.classList.contains("st-dialog--visible");
  }

  openBy(target) {
    this.toggleClass(true);

    const alert = this.dialogTarget.querySelector('.alert');
    if (alert) alert.remove();

    if (this.hasFocusTarget) {
      this.focusTarget.focus();
    }

    this.dispatch("opened", { detail: { target: target } });
  }

  closeBy(target) {
    this.toggleClass(false);

    if (target.getAttribute('data-ui--dialog-target') === 'modal') {
      document.body.classList.remove("overflow-hidden");
    }
    this.dispatch("closed", { detail: { target: target } });
  }

  // Refactor Me
  // This needs to be combined with the toggle method in sheet_controller
  toggleClass(visible) {
    if (visible) {
      this.dialogTarget.classList.remove("tw-hidden");
      this.dialogTarget.dataset.state = "open";
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.remove("tw-hidden");
        this.backdropTarget.dataset.state = "open";
      }
      if (this.hasModalTarget) {
        this.modalTarget.classList.remove("tw-hidden");
        this.modalTarget.dataset.state = "open";
      }
    } else {
      this.dialogTarget.dataset.state = "closed";

      setTimeout(() => {
        this.dialogTarget.classList.add("tw-hidden");
        if (this.hasBackdropTarget) {
          this.backdropTarget.classList.add("tw-hidden");
          this.backdropTarget.dataset.state = "closed";
        }
        if (this.hasModalTarget) {
          this.modalTarget.classList.add("tw-hidden");
          this.modalTarget.dataset.state = "closed";
        }
      }, 120);
    }
  }
}
